export createClient from './create-client';



/** WEBPACK FOOTER **
 ** ./~/roc-package-web-app-react/app/client/index.js
 **/